import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(assets-explorer)/search/[[...params]]/page.tsx");
